import validators from '@utils/validators';

const validate = (values) => {
    const errors ={};

    Object.assign(errors, validators.required(values.duration, 'duration'));

    if (values.duration) {
        Object.assign(errors, validators.floatAndNumbersWithFixedDecimal({value: values.duration, decimal: 1}, 'duration'));

        if (0 >= values.duration) {
            errors.duration = 'Duration must be greater than 0';
        }
    }

    return errors;
};

export default validate;
